import { State_update, State_init } from "./State.fs.js";
import { view } from "./View.fs.js";
import { Page, Model__get_Headline } from "./Types.fs.js";
import { PageHeader } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { singleton, ofArray, tail, head, isEmpty } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { parse } from "../../../fable_modules/fable-library-js.4.19.0/Int32.js";
import { int32ToString } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { WebPart$3 } from "../../../../Bfs.Web.Portale/WebPart.fs.js";

export const Part = new WebPart$3(State_init, State_update, view, (model_1) => (new PageHeader(1, [Model__get_Headline(model_1)])), (_arg_2) => (!isEmpty(_arg_2) ? ((head(_arg_2) === "news") ? (!isEmpty(tail(_arg_2)) ? ((head(tail(_arg_2)) === "page") ? (isEmpty(tail(tail(_arg_2))) ? (new Page(1, [head(tail(_arg_2))])) : (isEmpty(tail(tail(tail(_arg_2)))) ? (new Page(0, [parse(head(tail(tail(_arg_2))), 511, false, 32)])) : undefined)) : (isEmpty(tail(tail(_arg_2))) ? (new Page(1, [head(tail(_arg_2))])) : undefined)) : (new Page(0, [1]))) : undefined) : undefined), (_arg_1) => {
    if (_arg_1.tag === 1) {
        return ofArray(["news", _arg_1.fields[0]]);
    }
    else if (_arg_1.fields[0] === 1) {
        return singleton("news");
    }
    else {
        return ofArray(["news", "page", int32ToString(_arg_1.fields[0])]);
    }
}, (_arg) => undefined);

//# sourceMappingURL=WebPart.fs.js.map
